/**
 * This is separate from the panel-config to avoid circular reference - the grid uses this for saved views
 */
export const ExternalFileViewerKey = 'external-file-viewer-ggo2q' // <-- DO NOT CHANGE THIS. The layout manager depends on this value.
export const ExternalFileViewerMainGridKey = `${ExternalFileViewerKey}-MainGrid`
export const ExternalFileViewerDetailsGridKey = `${ExternalFileViewerKey}-DetailsGrid`
